import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { UnsavedChangesService } from '@app/services/unsaved-changes.service';

@Component({
  selector: 'app-sme-layout',
  templateUrl: './sme-layout.component.html',
  styleUrl: './sme-layout.component.scss'
})
export class SMELayoutComponent {
  constructor(
    private location: Location,
    private router: Router,
    private auth: AuthService,
    private unsaved: UnsavedChangesService
  ) {}

  goBack(): void {
    this.unsaved.runIfSafe(() => {
      if (window.history.length > 1) {
        this.location.back();
      } else {
        this.router.navigateByUrl('/SME/chat');
      }
    });
  }

  requestLogout(): void {
    this.unsaved.runIfSafe(() => {
      this.auth.logout();
      this.router.navigate(['/login']);
    });
  }
}
